import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { useAdminStore } from '../store/adminStore';

export function UserProtected({ children, requireAccess = false }) {
  const { user, token, refreshMe } = useAuthStore();
  const location = useLocation();
  const [checked, setChecked] = useState(!!user);
  useEffect(() => {
    if (token && !user) { refreshMe().finally(() => setChecked(true)); }
    else setChecked(true);
  }, [token, user, refreshMe]);

  if (!token) return <Navigate to="/login" state={{ from: location }} replace />;
  if (!checked) return <FullPageLoader />;
  if (requireAccess && !user?.has_access) return <Navigate to="/purchase" replace />;
  return children;
}

export function AdminProtected({ children }) {
  const { admin, token } = useAdminStore();
  const location = useLocation();
  if (!token || !admin) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return children;
}

export function FullPageLoader() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-ee-bg">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 rounded-full border-2 border-gold/30 border-t-gold animate-spin" />
        <span className="text-ee-muted text-sm">Loading…</span>
      </div>
    </div>
  );
}
